import { updateMols, updateState } from '../../../state';
import { removeAtomOrBond } from '../../molecule-object.utils';
import {
  REMOVE_MODE,
  MOL_MOUSE_EVENT,
  MOUSE_DOWN,
  MOUSE_MOVE,
  MOUSE_UP,
  REMOVE_COLOR,
} from '../../../../etc/constants';

const initial = {
  type: REMOVE_MODE,
  data: null,
};

function effect(state, action) {
  if (action.type !== MOL_MOUSE_EVENT) {
    return {};
  }

  return baseEffect(state.mols, state.mode, action.event, state.mouse.molIndex);
}

function baseEffect(mols, mode, event, molIndex) {
  if (event.type === MOUSE_MOVE) {
    return {};
  }

  const data = mode.data;
  let newMol = mols[molIndex];

  if (event.type === MOUSE_DOWN && data != null) {
    //
  } else if (event.type === MOUSE_UP && data == null) {
    if (event.atom) {
      newMol = removeAtomOrBond(newMol, newMol.atoms[event.idx]);
    } else if (event.bond) {
      newMol = removeAtomOrBond(newMol, undefined, newMol.bonds[event.idx]);
    } else if (event.empty) {
      //
    }
  } else if (event.type === MOUSE_DOWN && data == null) {
    //
  } else if (event.type === MOUSE_UP && data != null) {
    //
  }

  return { mols: updateMols(mols, newMol, molIndex) };
}

function preview(state) {
  const { lastMove, molIndex } = state.mouse;
  if (lastMove != null && (lastMove.atom || lastMove.bond)) {
    const mouseDownEvent = updateState(lastMove, { type: MOUSE_DOWN });
    const mouseDownPreviewState = baseEffect(state.mols, state.mode, mouseDownEvent, molIndex);
    const mouseUpEvent = updateState(lastMove, { type: MOUSE_UP });
    const previewState = baseEffect(mouseDownPreviewState.mols, state.mode, mouseUpEvent, molIndex);
    const previewMol = previewState.mols[molIndex];

    if (previewMol != null && previewMol !== state.mols[molIndex]) {
      const editedAtoms = {};
      for (const [key, atom] of Object.entries(state.mols[molIndex].atoms)) {
        if (previewMol.atoms[key] == null) {
          editedAtoms[key] = { ...atom, preview: true, color: REMOVE_COLOR };
        }
      }

      const editedBonds = {};
      for (const [key, bond] of Object.entries(state.mols[molIndex].bonds)) {
        if (previewMol.bonds[key] == null) {
          editedBonds[key] = { ...bond, preview: true, color: REMOVE_COLOR };
        }
      }

      return updateState(state.mols[molIndex], {
        atoms: updateState(state.mols[molIndex].atoms, editedAtoms),
        bonds: updateState(state.mols[molIndex].bonds, editedBonds),
      });
    }
  }

  return null;
}

function cleanup(mode) {
  return mode;
}

export const trait = {
  type: REMOVE_MODE,
  initial,
  effect,
  preview,
  cleanup,
};
